import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_REGISTRATION_SUCCESS,
  GET_REGISTRATION_FAILED,
  GET_REGISTRATION_REQUESTED,
} from 'resources/actionTypes';
import { RegistrationApi } from 'services/RegistrationService';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from 'redux/store';
import { onLoaderTrigger } from 'redux/actions/CommonAction';

function* fetchRegistration(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userRegistration = yield call(RegistrationApi, payload.userRegistration?.userDetails);
  if (userRegistration.success) {
    yield put({
      type: GET_REGISTRATION_SUCCESS,
      userRegistration: userRegistration,
    });

    if(payload?.userRegistration?.actionType === "signup") {
      const userDetails = {
        mobile: payload?.userRegistration?.userDetails?.mobile,
        email: payload?.userRegistration?.userDetails?.email,
        companyName: payload?.userRegistration?.userDetails?.companyName,
        code: payload?.userRegistration?.userDetails?.countryCode,
        location: payload?.userRegistration?.userDetails?.location
      }
      localStorage.setItem('signUpDetails', JSON.stringify(userDetails));
      payload.navigate('/otp?pageType=signupOtp');
    }

    toast.success(userRegistration.message);
    store.dispatch(onLoaderTrigger(false));
     

    
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_REGISTRATION_FAILED,
      message: userRegistration.message,
    });
      toast.error(userRegistration.message || 'Login failed');
  }
}
function* registrationSaga() {
  yield takeEvery(GET_REGISTRATION_REQUESTED, fetchRegistration);
}

export default registrationSaga;
